import React, { useEffect, useMemo, useState } from 'react'
import { Stack, HStack, Box } from "@chakra-ui/react"
import { StaticImage } from 'gatsby-plugin-image'
import sample from 'lodash/sample'

import Link from '../components/Link'
import { WAITING_LIST_AB_TEXT, WAITING_LIST_SRC } from '../constants/storage'
import useImpression from '../hooks/useImpression'

const pathnames = [
  '/',
  '/login',
  '/logout',
  // '/404',
]

const messages = [
  `喜歡 {name} 的頁面嗎？自己做一個吧！`,
  `{name} 今天用了傳送門，你呢？`,
  `立即取得你的傳送門~`,
]

const Footer = ({ location, pageContext }) => {
  const [abText, setAbText] = useState('')
  // const router = useRouter()
  useEffect(() => {
    const abMessage = sample(messages)
    window.sessionStorage.setItem(WAITING_LIST_AB_TEXT, abMessage)
    // const isHidden = props.data?.['waiting-list']?.isHidden
    setAbText(abMessage.replace('{name}', pageContext.name))
  }, [pageContext.name])
  const noFooter = pathnames.includes(location.pathname)
  const isAdminPage = location.pathname.startsWith('/admin')
  const handleTrackEvent = trackerName => () => {
    if (trackerName && typeof window.gtag === 'function') {
      window.gtag("event", "click_button", {
        button_name: trackerName,
      });
    }
    window.sessionStorage.setItem(WAITING_LIST_SRC, trackerName)
  }
  const trackImpression = trackerName => {
    if (trackerName && typeof window.gtag === 'function') {
      window.gtag("event", "button_visible", {
        button_name: trackerName,
      });
      return true
    }
  }
  const logoRef = useImpression(() => trackImpression('footer.logo'))
  const textRef = useImpression(() => trackImpression(`footer.${window.sessionStorage.getItem(WAITING_LIST_AB_TEXT)}`))
  const waitingListUrl = `${pageContext.slug ? `/${pageContext.slug}` : ''}/waiting-list`
  return !noFooter && (
    <Box
      as="footer"
      py="4"
      bg="white"
      fontSize="0.875em"
      textAlign="center"
    >
      <Link
        to={waitingListUrl}
        className="footer-waiting-list"
        onClick={handleTrackEvent('footer.logo')}
        ref={logoRef}
      >
        <StaticImage src="../images/logo-black.png" alt="Portaly 傳送門" width={112} height={56} placeholder="blurred" />
      </Link>
      <HStack spacing={4} justifyContent="center">
        {isAdminPage ? (
          <>
            <Link to="/terms" onClick={handleTrackEvent('footer.terms')}>使用條款</Link>
            <Link isExternal onClick={handleTrackEvent('footer.contact')} href="mailto:service@realengine.com.tw">聯絡信箱</Link>
          </>
        ) : (
          <Link
            to={waitingListUrl}
            className="footer-waiting-list"
            data-name="text"
            onClick={() => handleTrackEvent(`footer.${window.sessionStorage.getItem(WAITING_LIST_AB_TEXT)}`)()}
            ref={textRef}
          >
            {abText}
          </Link>
        )}
      </HStack>
    </Box>
  )
}

export default Footer
